import React from 'react';
import { StyleSheet, View } from 'react-native';
import { BodyText, theme, useResponsive } from '@sg/garnish';

import { useTrademark } from '@order/hooks';
import { useLocalizationContext } from '@order/Localization';

import { DebugMenuTrigger } from '../../DebugMenu';

export const OrganizationLinksFooterCopyright = () => {
  const { t } = useLocalizationContext();
  const { match } = useResponsive();

  const trademark = useTrademark();

  const textStyle = match([undefined, styles.copyrightAndAppVersionText]);
  const trademarkTextStyle = match([undefined, styles.trademarkText]);

  return (
    <View>
      <BodyText style={textStyle}>
        {t('footer.copyright', { year: CURRENT_YEAR })}
      </BodyText>

      {trademark ? (
        <BodyText style={trademarkTextStyle}>{trademark}</BodyText>
      ) : null}

      <BodyText style={textStyle}>
        <DebugMenuTrigger />
      </BodyText>
    </View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const CURRENT_YEAR = new Date().getFullYear();

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  copyrightAndAppVersionText: {
    textAlign: 'right',
  },
  trademarkText: {
    textAlign: 'right',
    marginBottom: theme.spacing['4'],
  },
});
